import React, { useState } from 'react';
import {
  Button,
  Divider,
  ListItemIcon, ListItemText, ListItemSecondaryAction,
  Menu, MenuItem,
  Tooltip,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreVert from '@material-ui/icons/MoreVert';
import { defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import styles from '../styles.module.css';
import CopyChart from './CopyChart';

const messages = defineMessages({
  MORE: {
    id: 'MORE',
    defaultMessage: 'More',
  },
  DELETE: {
    id: 'DELETE',
    defaultMessage: 'Delete',
  },
  EDIT: {
    id: 'EDIT',
    defaultMessage: 'Edit',
  },
  NEW_BOARD: {
    id: 'NEW_BOARD',
    defaultMessage: 'New Board',
  },
});

function ChartCardMenu({
  allowCopy,
  chart,
  deleteChart,
  editChart,
}) {
  const [anchorEl, setAnchorEl] = useState();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditChart = () => {
    editChart();
    handleClose();
  };

  const handleDeleteChart = () => {
    deleteChart();
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.MORE} />}>
        <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={handleClick}
          disableRipple
          className={styles.cardMenuBtn}
        >
          <MoreVert />
        </Button>
      </Tooltip>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ style: { marginTop: 48 } }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEditChart}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText primary={<FormattedMessage {...messages.EDIT} />} />
          <ListItemSecondaryAction />
        </MenuItem>

        {allowCopy && <CopyChart chartToCopy={chart} variant="menuItem" />}

        <Divider style={{ margin: '7px 0' }} />

        <MenuItem onClick={handleDeleteChart} classes={{ root: styles.deleteBtn }}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText primary={<FormattedMessage {...messages.DELETE} />} />
          <ListItemSecondaryAction />
        </MenuItem>
      </Menu>
    </>
  );
}

ChartCardMenu.defaultProps = {
  allowCopy: false,
  deleteChart: () => {},
  editChart: () => {},
};

ChartCardMenu.propTypes = {
  allowCopy: PropTypes.bool,
  chart: PropTypes.shape({}).isRequired,
  deleteChart: PropTypes.func,
  editChart: PropTypes.func,
};

export default ChartCardMenu;
